import React, { useState, useEffect, useCallback } from 'react';
import { Formik, Form, ErrorMessage } from 'formik';
import { createUseStyles } from 'react-jss';
import { FaFacebook, FaInstagram, FaSnapchatGhost, FaTrash, FaYoutube } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import LinkButton from '../components/LinkButton';
import { setAxiosToken } from '../actions/auth';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import DefaultLayout from '../layouts/DefaultLayout';
import Text from '../components/Text';
import FormikTextField from '../components/FormikTextField';
import FormikToggle from '../components/FormikToggle';
import FormikSelect from '../components/FormikSelect';
import FormikTextarea from '../components/FormikTextarea';
import FormikUploadButton from '../components/FormikUploadButton';
import Button from '../components/Button';
import { Category, City, Country } from '../types';
import {
  getAllCategories,
  getAllCities,
  createBusiness,
  getAllCountries,
  createCreater,
} from '../services/ApiService';
import Loader from '../components/Loader';
import FormikCheckbox from '../components/FormikCheckbox';
import { RootState } from '../config/store';
import { showRegisterModal } from '../actions/ui';
import FormikErrorMessage from '../components/FormikErrorMessage';
import { push } from 'connected-react-router';
import { BsFillPlusCircleFill } from 'react-icons/bs';
import { AiFillMinusCircle } from 'react-icons/ai';
import { ReactComponent as TikTokIcon } from '../assets/tik-tok.svg';
import clsx from 'clsx';

export interface ContentRegisterProps {
  history: any
}

const ContentRegister: React.FC<ContentRegisterProps> = ({ history }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [thankMessage, setThankMessage] = useState(false);
  const [categories, setCateogries] = useState<Category[]>([]);

  const [viewFacebook, setViewFacebook] = useState<boolean>(false);
  const [viewInstagram, setViewInstagram] = useState(false);
  const [viewYoutube, setViewYoutube] = useState(false);
  const [viewTiktok, setViewTiktok] = useState(false);
  const [viewSnapchat, setViewSnapchat] = useState(false);

  const userID = useSelector<RootState, string>((state) => state.auth.user?.id);

  const getKey = function (key: string, url: string = "") {
    if (url == "" && history?.location?.search) {
      url = history.location.search
    }
    if (url.indexOf(key) == -1) {
      return ""
    }
    let keyIndex = url.indexOf(key) + key.length + 1
    url = url.substring(keyIndex)
    let charIndex = url.indexOf("&");
    if (charIndex == -1)
      charIndex = url.length
    let value = url
    if (key == "option") {
      value = url.replace(/%22/g, "\"");
      // } else {
    }
    value = value.substring(0, charIndex)
    return value
  }
  const [token, setToken] = useState<string>(getKey("token"));



  useEffect(() => {
    (async () => {
      try {
        const cats = await getAllCategories();
        setCateogries(cats);
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (!userID && !token) {
      dispatch(showRegisterModal(false));
    }
    // MessageChannel.postMessage('Trigger from Javascript code');

    if (token) {
      setAxiosToken(token);
    }
  }, [userID, dispatch]);

  const handleSubmit = useCallback(
    (data, form: any) => {
      if (!userID && !token) {
        dispatch(showRegisterModal());
        return Promise.resolve();
      }
      return (async () => {
        try {
          const formData = new FormData();
          formData.append('user_id', userID);
          Object.keys(data).forEach((key) => {
            if (key === 'category') {
              data[key].forEach((cat: any) => {
                formData.append('specialities[]', cat.value);
              });
            } else if (data[key] != null && data[key] != "") {
              formData.append(key, data[key]);
            }
          });
          await createCreater(formData);
          form.resetForm();

          setThankMessage(true)
        } catch (e) {
          form.setSubmitting(false);
          const errors: any = {};
          if (e.response?.data?.error?.details) {
            Object.keys(e.response?.data?.error?.details).forEach((key) => {
              errors[key] = e.response?.data?.error?.details[key];
            });
            form.setErrors(errors);
          }
        }
      })();
    },
    [userID, dispatch],
  );

  return (
    <>
      <DefaultLayout history={history}>
        <Helmet>
          <title>Register your business | twigBIG | Social eCommerce Marketplace in Beauty and Fashion</title>
        </Helmet>
        <Loader center className={classes.loader} loading={loading}>
          {() => (
            <Container fluid className={classes.container}>
              {!thankMessage ?
                <Formik
                  initialValues={{
                    facebook: '',
                    facebook_followers: null,
                    instagram: '',
                    instagram_followers: null,
                    tiktok: '',
                    tiktok_followers: null,
                    youtube_channel: '',
                    youtube_subscribers: null,
                    snapchat: '',
                    snapchat_followers: null,
                    category: [],
                    terms: false
                  }}
                  // validationSchema={formSchema}
                  onSubmit={handleSubmit}
                >
                  {({
                    handleSubmit: handle,
                    setFieldValue,
                    values,
                    isValid,
                    isSubmitting,
                  }) => (
                    <Form onSubmit={handle}>
                      <Row>
                        <Col xs={12}>
                          <Text as="h5" bold>
                            Join Our Creators Program
                          </Text>
                          <br />
                          <Text as="h5" >
                            Benefits of joining the Creator Program:
                          </Text>
                          <Text as="h6" >
                            1- No minimum number of followers is required as long you are talented as we will help you to grow while monetizing your content in the most effective and long-lasting way.
                          </Text>
                          <Text as="h6" >
                            2- Free products samples.
                          </Text>
                          <Text as="h6" >
                            3- Accumulative monetization of your content on twigBIG i.e. A continuous, non-stop, income for you.

                          </Text>
                          <Text as="h6" >
                            4- Connecting you to a big network of cool brands and sellers.
                          </Text>
                          <Text as="h6" >
                            5- Be nominated for influencer campaigns and get selected by sellers.
                          </Text>
                          <br />

                          <Text as="h5" >
                            Steps to join Creator Program:
                          </Text>
                          <Text as="h6" >
                            1- Complete this form and approve the conditions.
                          </Text>
                          <Text as="h6" >
                            2- Submit at least 3 stories of your work on the app then share it over social media.
                          </Text>
                          <Text as="h6" >
                            3- After reviewing your profile and content in your social accounts and twigBIG, we have the right to approve or reject you. If approved, we will share a dedicated code for you that you can promote. If rejected, keep submitting review stories "twigs" on the app then submit the form again. The content must be authentic and credible about the products that you are reviewing. The code will have a specific rate commission which will increase based on your performance.
                          </Text>
                          <Text as="h6" >
                            4- You can select any product from the store to create a review content "twig" about by clicking on "twig it" from the product screen.
                          </Text>
                          <Text as="h6" bold>
                            Golden rule: The more quality twigs you share on the app and your networks, the higher commission you get and free samples from sellers/brands you get.                          </Text>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: "50px" }}>
                        <Col xs={12} lg={6}>
                          <Text as="p">
                            Start by selecting the product types that you would like to create content about
                          </Text>
                          <div className={clsx(classes.inputBox, classes.catgoryInputBox)}>
                            <FormikSelect
                              name="category"
                              placeholder="Select products' categories"
                              options={categories.map((category) => ({
                                label: category.name,
                                value: category.name,
                              }))}
                              isMulti
                            />
                            <FormikErrorMessage name="categories" />
                          </div>
                        </Col>
                        <Col xs={12} lg={6}>

                          <Text as="p">
                            Now, please fillup the social networks that you are popular on:
                          </Text>
                          <div className={classes.social} onClick={() =>
                            setViewFacebook(!viewFacebook)
                          }>
                            <Text className={clsx(classes.socialTitle)} as="h3">
                              <FaFacebook className={clsx(classes.socialIcon, classes.socialIconFacebook)}></FaFacebook>
                              Facebook
                            </Text>

                            <div className={classes.socialAddIcon}>
                              <FormikCheckbox
                                width="20px"
                                height="20px"
                                id="is_interested_creator"
                                name="is_interested_creator"
                                checked={viewFacebook}
                              />
                            </div>
                          </div>
                          {
                            viewFacebook ? <>
                              <div className={classes.inputDiv}>
                                <div className={classes.inputBox}>
                                  <FormikTextField
                                    name="facebook"
                                    placeholder="Username"
                                  />
                                  <FormikErrorMessage name="facebook" />
                                </div>

                                <div className={classes.inputBox}>
                                  <FormikTextField
                                    type="number"
                                    name="facebook_followers"
                                    placeholder="Number of followers"
                                  />
                                  <FormikErrorMessage name="facebook_followers" />
                                </div>
                              </div>
                            </> : null
                          }

                          <div className={classes.social} onClick={() =>
                            setViewInstagram(!viewInstagram)
                          }>
                            <Text className={clsx(classes.socialTitle)} as="h3">
                              <FaInstagram className={clsx(classes.socialIcon, classes.socialIconInstagramCustom)}></FaInstagram>

                              Instagram
                            </Text>
                            {/* {
                              !viewInstagram ?
                                <BsFillPlusCircleFill className={classes.socialAddIcon}></BsFillPlusCircleFill>
                                : <AiFillMinusCircle className={classes.socialAddIcon}></AiFillMinusCircle>
                            } */}

                            <div className={classes.socialAddIcon}>
                              <FormikCheckbox
                                width="20px"
                                height="20px"
                                id="is_interested_creator"
                                name="is_interested_creator"
                                checked={viewInstagram}
                              />
                            </div>
                          </div>

                          {
                            viewInstagram ?
                              <>
                                <div className={classes.inputDiv}>

                                  <div className={classes.inputBox}>
                                    <FormikTextField
                                      name="instagram"
                                      placeholder="Username"
                                    />
                                    <FormikErrorMessage name="instagram" />
                                  </div>
                                  <div className={classes.inputBox}>
                                    <FormikTextField
                                      type="number"
                                      name="instagram_followers"
                                      placeholder="Number of followers"
                                    />
                                    <FormikErrorMessage name="instagram_followers" />
                                  </div>
                                </div>
                              </>
                              : null
                          }


                          <div className={classes.social} onClick={() =>
                            setViewYoutube(!viewYoutube)
                          }>
                            <Text className={clsx(classes.socialTitle)} as="h3">
                              <FaYoutube className={clsx(classes.socialIcon, classes.socialIconYoutube)}></FaYoutube>

                              Youtube
                            </Text>
                            {/* {
                              !viewYoutube ?
                                <BsFillPlusCircleFill className={classes.socialAddIcon}></BsFillPlusCircleFill>
                                : <AiFillMinusCircle className={classes.socialAddIcon}></AiFillMinusCircle>
                            } */}
                            <div className={classes.socialAddIcon}>
                              <FormikCheckbox
                                width="20px"
                                height="20px"
                                id="is_interested_creator"
                                name="is_interested_creator"
                                checked={viewYoutube}
                              />
                            </div>
                          </div>

                          {
                            viewYoutube ? <>
                              <div className={classes.inputDiv}>

                                <div className={classes.inputBox}>
                                  <FormikTextField
                                    name="youtube_channel"
                                    placeholder="Username"
                                  />
                                  <FormikErrorMessage name="youtube_channel" />
                                </div>

                                <div className={classes.inputBox}>
                                  <FormikTextField
                                    name="youtube_subscribers"
                                    type="number"
                                    placeholder="Number of followers"
                                  />
                                  <FormikErrorMessage name="youtube_subscribers" />
                                </div>
                              </div>
                            </>
                              : null}


                          <div className={classes.social} onClick={() =>
                            setViewSnapchat(!viewSnapchat)
                          }>
                            <Text className={clsx(classes.socialTitle)} as="h3">
                              <FaSnapchatGhost className={clsx(classes.socialIcon, classes.socialIconSnapchat)}></FaSnapchatGhost>

                              Snapchat
                            </Text>
                            {/* {
                              !viewSnapchat ?
                                <BsFillPlusCircleFill className={classes.socialAddIcon}></BsFillPlusCircleFill>
                                : <AiFillMinusCircle className={classes.socialAddIcon}></AiFillMinusCircle>
                            } */}

                            <div className={classes.socialAddIcon}>
                              <FormikCheckbox
                                width="20px"
                                height="20px"
                                id="is_interested_creator"
                                name="is_interested_creator"
                                checked={viewSnapchat}
                              />
                            </div>
                          </div>

                          {
                            viewSnapchat ?
                              <>
                                <div className={classes.inputDiv}>

                                  <div className={classes.inputBox}>
                                    <FormikTextField
                                      name="snapchat"
                                      placeholder="Username"
                                    />
                                    <FormikErrorMessage name="snapchat" />
                                  </div>
                                  <div className={classes.inputBox}>
                                    <FormikTextField
                                      type="number"
                                      name="snapchat_followers"
                                      placeholder="Number of followers"
                                    />
                                    <FormikErrorMessage name="snapchat_followers" />
                                  </div>
                                </div>
                              </> : null
                          }


                          <div className={classes.social} onClick={() =>
                            setViewTiktok(!viewTiktok)
                          }>
                            <Text className={clsx(classes.socialTitle)} as="h3">
                              <TikTokIcon className={classes.socialIcon} />
                              Tiktok
                            </Text>
                            {/* {
                              !viewTiktok ?
                                <BsFillPlusCircleFill className={classes.socialAddIcon}></BsFillPlusCircleFill>
                                : <AiFillMinusCircle className={classes.socialAddIcon}></AiFillMinusCircle>
                            } */}

                            <div className={classes.socialAddIcon}>
                              <FormikCheckbox
                                width="20px"
                                height="20px"
                                id="is_interested_creator"
                                name="is_interested_creator"
                                checked={viewTiktok}
                              />
                            </div>
                          </div>

                          {
                            viewTiktok ? <>
                              <div className={classes.inputDiv}>

                                <div className={classes.inputBox}>
                                  <FormikTextField
                                    name="tiktok"
                                    placeholder="Username"
                                  />
                                  <FormikErrorMessage name="tiktok" />
                                </div>
                                <div className={classes.inputBox}>
                                  <FormikTextField
                                    name="tiktok_followers"
                                    type="number"
                                    placeholder="Number of followers"
                                  />
                                  <FormikErrorMessage name="tiktok_followers" />
                                </div>
                              </div>

                            </> : null}


                        </Col>

                        {/*<Col xs={12} lg={4}>
                         

                          <div className={classes.social} onClick={() =>
                            setViewYoutube(!viewYoutube)
                          }>
                            <Text className={clsx(classes.socialTitle)} as="h3">
                              <FaYoutube className={clsx(classes.socialIcon, classes.socialIconYoutube)}></FaYoutube>

                              Youtube
                            </Text>
                            {
                              !viewYoutube ?
                                <BsFillPlusCircleFill className={classes.socialAddIcon}></BsFillPlusCircleFill>
                                : <AiFillMinusCircle className={classes.socialAddIcon}></AiFillMinusCircle>
                            }
                          </div>

                          {
                            viewYoutube ? <>
                              <div className={classes.inputBox}>
                                <FormikTextField
                                  name="youtube_channel"
                                  placeholder="Youtube Channel"
                                />
                                <FormikErrorMessage name="youtube_channel" />
                              </div>

                              <div className={classes.inputBox}>
                                <FormikTextField
                                  name="youtube_subscribers"
                                  placeholder="Youtube Subscribers"
                                />
                                <FormikErrorMessage name="youtube_subscribers" />
                              </div>
                            </>
                              : null}


                          <div className={classes.social} onClick={() =>
                            setViewSnapchat(!viewSnapchat)
                          }>
                            <Text className={clsx(classes.socialTitle)} as="h3">
                              <FaSnapchatGhost className={clsx(classes.socialIcon, classes.socialIconSnapchat)}></FaSnapchatGhost>

                              Snapchat
                            </Text>
                            {
                              !viewSnapchat ?
                                <BsFillPlusCircleFill className={classes.socialAddIcon}></BsFillPlusCircleFill>
                                : <AiFillMinusCircle className={classes.socialAddIcon}></AiFillMinusCircle>
                            }
                          </div>

                          {
                            viewSnapchat ?
                              <>
                                <div className={classes.inputBox}>
                                  <FormikTextField
                                    name="snapchat"
                                    placeholder="Snapchat"
                                  />
                                  <FormikErrorMessage name="snapchat" />
                                </div>
                                <div className={classes.inputBox}>
                                  <FormikTextField
                                    name="snapchat_followers"
                                    placeholder="Snapchat Followers"
                                  />
                                  <FormikErrorMessage name="snapchat_followers" />
                                </div>
                              </> : null
                          }
                        </Col>

                        <Col xs={12} lg={4}>
                     

                          <div className={classes.social} onClick={() =>
                            setViewTiktok(!viewTiktok)
                          }>
                            <Text className={clsx(classes.socialTitle)} as="h3">
                              <TikTokIcon className={classes.socialIcon} />
                              Tiktok
                            </Text>
                            {
                              !viewTiktok ?
                                <BsFillPlusCircleFill className={classes.socialAddIcon}></BsFillPlusCircleFill>
                                : <AiFillMinusCircle className={classes.socialAddIcon}></AiFillMinusCircle>
                            }
                          </div>

                          {
                            viewTiktok ? <>
                              <div className={classes.inputBox}>
                                <FormikTextField
                                  name="tiktok"
                                  placeholder="Tiktok"
                                />
                                <FormikErrorMessage name="tiktok" />
                              </div>
                              <div className={classes.inputBox}>
                                <FormikTextField
                                  name="tiktok_followers"
                                  placeholder="Tiktok Followers"
                                />
                                <FormikErrorMessage name="tiktok_followers" />
                              </div>
                            </> : null}


                        </Col> */}

                      </Row>

                      <Row>
                        <Col xs={1} lg={3}></Col>

                        <Col xs={10} lg={6}>
                          <div className={classes.termsBox}>
                            <FormikCheckbox
                              id="terms"
                              name="terms"
                              checked={values.terms}
                            />
                            <label htmlFor="terms">
                              <Text bold as="span">
                                I accept{' '}
                                <a
                                  className={classes.paragraph}
                                  href="https://twigbig.com/terms-and-conditions"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Terms
                                </a>{' '}
                                and{' '}
                                <a
                                  className={classes.paragraph}
                                  href="https://twigbig.com/privacy-policy"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Privacy Policy
                                </a>
                              </Text>
                            </label>
                          </div>

                          {isSubmitting ? (
                            <Loader center loading />
                          ) : (
                            <Button
                              type="submit"
                              disabled={!isValid || !values.terms || isSubmitting}
                              block
                            >
                              <Text className="m-0" color="white" bold>
                                Submit
                              </Text>
                            </Button>
                          )}
                        </Col>
                        <Col xs={1} lg={3}></Col>

                      </Row>
                    </Form>
                  )}
                </Formik>
                :
                <div className={classes.thankYouBox}>
                  <Text as="h2" align="center">
                    Thank you for registering, we will review your request and get back to you shortly              </Text>
                  <Text align="center">
                    For any inquiries, please email us at support@twigbig.com              </Text>
                  <LinkButton to="/" target="_self" isLink={true} >
                    <Text color='white' as="span" bold capitalized>
                      Back to home
                    </Text>
                  </LinkButton>
                </div>
              }
            </Container>
          )}
        </Loader>
      </DefaultLayout>
    </>
  );
};

const useStyles = createUseStyles({
  loader: {
    paddingTop: '50vh',
  },
  container: {
    marginTop: '2rem',
    maxWidth: '85vw',
  },
  inputDiv: {
    display: 'flex',
    marginLeft: "30px",
    justifyContent: "space-evenly"
  },
  inputBox: {
    marginBottom: '2rem',
  },
  catgoryInputBox: {
    maxWidth: "450px"
  },
  flexLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  uploadContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cancelUploadBtn: {
    border: 'none',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    width: '64px',
    height: '64px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    color: ' #f1f1f1',
    fontSize: '27px',
    marginLeft: '15px',
    '&:focus': {
      outline: 'none',
    },
  },
  paragraph: {
    color: '#9D7CFA !important',
    '&:hover': {
      color: '#9D7CFA',
    },
    '&:visited': {
      color: '#9D7CFA !important',
      textDecoration: 'underline',
    },
  },
  termsBox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '2rem',
  },
  thankYouBox: {
    textAlign: "center",
    paddingTop: '55px',
    '& > h2': {
      marginBottom: "40px"
    },
    '& > p': {
      marginBottom: "20px !important"
    },
  },

  social: {
    position: "relative",
    padding: "8px 5px",
    margin: "0px 5px 25px",
    borderRadius: "5px"
  },
  socialTitle: {
    fontSize: "18px",
    marginTop: "5px",
    marginBottom: "0px"
  },
  socialAddIcon: {
    position: "absolute",
    top: "11px",
    right: "50%"
  },
  '@media (max-width: 768px)': {
    socialAddIcon: {
      right: "20%",
    },
  },
  socialIcon: {
    fontSize: "16px",
    marginTop: "-3px",
    width: "20px",
    height: "20px",
    marginRight: "10px"
  },
  socialIconFacebook: {
    color: "#0d89f0 !important"
  },
  socialIconYoutube: {
    color: "red !important"
  },
  socialIconSnapchat: {
    color: "#f7f401 !important"
  },
  socialIconTiktok: {
    color: "#000 !important"
  },
  socialIconInstagram: {
    background: "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)",
    "-webkitBackgroundClip": "text",
    backgroundClip: "text",
    "-webkitTextFillColor": "transparent"
  },
  socialIconInstagramCustom: {
    color: "#fd8c62"
  }
});

export default ContentRegister;
